import React, { useState, useEffect } from "react";
import { channelListUser, purposeListUser, purposeFinnalPut } from "apis/user";
import { Modal, Input, Button, Checkbox, Row, Col, Tag } from "antd";
import { showMessage } from "utils";
import "../../userCommon.css";

const AlertFn = ({ onClose, visible, token, onHasName }) => {
  const { CheckableTag } = Tag;
  const [step, setStep] = useState(0);
  const [channel, setChannel] = useState([]);
  const [purpose, setPurpose] = useState([]);
  const [stepData, setStepData] = useState({
    channels: [],
    purposes: []
  });
  const getList = () => {
    channelListUser().then(res => {
      setChannel(res);
    });
    purposeListUser().then(res => {
      setPurpose(res);
    });
  };
  const getArr = (arr, checkedValues) => {
    if (arr.length > 0) {
      const index = arr.indexOf(checkedValues);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(checkedValues);
      }
    } else {
      arr.push(checkedValues);
    }
    return arr;
  };
  const onChange = (checkedValues, type) => {
    if (type === 1) {
      const channelArr = JSON.parse(JSON.stringify(stepData.channels));
      setStepData({
        ...stepData,
        channels: getArr(channelArr, checkedValues)
      });
    } else if (type === 2) {
      const purposesArr = JSON.parse(JSON.stringify(stepData.purposes));
      setStepData({
        ...stepData,
        purposes: getArr(purposesArr, checkedValues)
      });
    } else {
      setStepData({ ...stepData, name: checkedValues });
    }
  };
  const finnal = () => {
    purposeFinnalPut(stepData, token).then(() => {
      showMessage("success", "提交成功，感谢您的提交~");
      onClose();
      // if (setStep.name) {
      //   onHasName();
      // }
    });
  };
  useEffect(() => {
    getList();
  }, []);
  return (
    <Modal title="" onCancel={onClose} visible={visible} footer={false}>
      {step === 0 && (
        <div className="registerOne">
          <h3 className="zcTitleStep1" style={{ marginTop: 0 }}>
            您是通过什么渠道知道和了解调研工厂呢？
          </h3>
          <Row>
            {channel.map(x => {
              return (
                <Col span={8}>
                  <CheckableTag
                    key={x.id}
                    checked={stepData.channels.indexOf(x.id) > -1}
                    onChange={() => {
                      onChange(x.id, 1);
                    }}
                  >
                    {x.name}
                  </CheckableTag>
                </Col>
              );
            })}
          </Row>
          <h3 className="zcTitleStep1">您使用调研工厂的目的是？</h3>
          <Row>
            {purpose.map(x => {
              return (
                <Col span={12}>
                  <CheckableTag
                    key={x.id}
                    checked={stepData.purposes.indexOf(x.id) > -1}
                    onChange={() => {
                      onChange(x.id, 2);
                    }}
                  >
                    {x.name}
                  </CheckableTag>
                </Col>
              );
            })}
          </Row>
          <div className="btns" style={{ marginTop: 30 }}>
            <Button
              type="primary"
              style={{ height: 30 }}
              onClick={() => {
                if (
                  stepData.purposes.includes(2) ||
                  stepData.purposes.includes(3)
                ) {
                  setStep(2);
                } else {
                  finnal();
                }
                console.log(stepData);
              }}
            >
              提交
            </Button>
            <a
              onClick={() => {
                onClose();
              }}
              style={{ color: "#888", fontSize: 12, marginLeft: 20 }}
            >
              跳过
            </a>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="registerOne">
          <h3 className="zcTitleStep1" style={{ marginTop: 0 }}>
            为了更好的为您提供服务，请先填写您的姓名
          </h3>
          <Input
            placeholder="请输入您的姓名"
            onChange={e => {
              onChange(e.target.value, 3);
            }}
          />
          <div className="btns" style={{ marginTop: 30 }}>
            <Button
              type="primary"
              style={{ height: 30 }}
              onClick={() => {
                finnal();
              }}
            >
              提交
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default AlertFn;
